const uiSchema = () => ({
  password: {
    'ui:placeholder': '********',
    'ui:widget': 'password',
    'ui:options': {
      xs: 12,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
    },
  },
});

export default uiSchema;
